import Base from './Base';

export default class SlackChannel extends Base {
    get channel() {
        return this.channels.find(item => item.id === this.channel_id);
    }
    get channelName() {
        if (!this.channel) return '';

        return this.channel.name;
    }
}
